<section id="section-report" class="container-fluid mt-1 ">
  <div class="row" *ngIf="internalOrderModel">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{internalOrderModel.internalOrderId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{internalOrderModel.internalOrderId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nit Empresa -->
                  <p id="nit-empresa-{{internalOrderModel.internalOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{internalOrderModel.enterpriseNit}}</p>

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{internalOrderModel.internalOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{internalOrderModel.enterpriseName}}</p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{internalOrderModel.internalOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{internalOrderModel.branchName}}</p>

                  <!--Nombre Pedido -->
                  <p id="nombre-pedido-interno-{{internalOrderModel.internalOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    Pedido Interno Nro.{{internalOrderModel.consecutive}}</p>

                  <!-- Fecha  -->
                  <label id="t-fecha-pedido-interno-{{internalOrderModel.internalOrderId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-fecha-pedido-interno' |
                    formatLabelPipe : elementsLabel}}</label>

                  <p id="fecha-pedido-interno-{{internalOrderModel.internalOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{(internalOrderModel.dateInternalOrder | date: 'dd/MM/yyyy')}}</p>

                  <!-- Responsable -->
                  <label id="t-responsable-{{internalOrderModel.internalOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-responsable' | formatLabelPipe : elementsLabel}}</label>
                  <p id="responsable-{{internalOrderModel.internalOrderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{internalOrderModel.responsible}}</p>

                  <!-- Observación  -->
                  <label id="t-observacion-{{internalOrderModel.internalOrderId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-observacion' |
                    formatLabelPipe : elementsLabel}}</label>

                  <p id="observacion-{{internalOrderModel.internalOrderId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> {{
                    internalOrderModel.observation}}
                  </p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-pedido-interno-{{internalOrderModel.internalOrderId}}"
                  [columns]="columns" [data]="internalOrderModel.internalOrderDetails!" [idMap]="idMap"
                  [documentId]="internalOrderModel.internalOrderId!" [footerVisible]="true" [editFormat]="editFormat"
                  (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>